<div id="viewer-container"></div>
<!-- <app-map-legend [state]="status" [component]="legendsMode" [step]="step"></app-map-legend> -->
<!-- POPPER TOOLTIP -->
<div id="tooltip" class="popover tk3dpopover" role="tooltip" style="pointer-events: none;">
  <div id="arrow" data-popper-arrow></div>
  <h3 class="popover-header"></h3>
  <div class="popover-body"></div>
</div>
